import React, { useState, useEffect } from 'react'
import Footer from '../../CoreComponents/Footer'
import Header from '../../CoreComponents/Header'
import MainHeader from '../../CoreComponents/MainHeader'
import NavBar from '../../CoreComponents/NavBar'


function Body() {
    const [name, setName] = useState('Category name')
    const [image, setImage] = useState(null)
    const [imgData, setImgData] = useState(null);
    const [icon, setIcon] = useState({})
    const submitHandler = (e) => {
        e.preventDefault()
        // setImage(e.target.files[0])
        const reader = new FileReader();
        reader.addEventListener("load", () => {
            setImgData(reader.result);

        })
        reader.readAsDataURL(e.target.files[0]);

    }
    const onChangeImage = () => {

    }
    const submitHandler1 = (e) => {
        e.preventDefault()
        // setIcon(e.target.files[0])
        // alert('');
        const reader = new FileReader();
        reader.addEventListener("load", () => {
            setIcon(reader.result);

        })
        reader.readAsDataURL(e.target.files[0]);

    }

    const handlingSubmit = (e) => {
        e.preventDefault()
        // void 0
        // void 0
        // void 0
    }
    return (
        <div>
            <div>
                <div class="content-body">
                    <div class="container-fluid">
                        <div class="page-titles">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="javascript:void(0)">Categories</a></li>
                                <li class="breadcrumb-item active"><a href="javascript:void(0)">Edit Categories</a></li>
                            </ol>
                        </div>
                        <div className="col-xl-12 col-lg-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">Edit Category</h4>
                                </div>
                                <div className="card-body">
                                    <div className="basic-form">
                                        <form onSubmit={handlingSubmit}>
                                            <div className="form-group row">
                                                <label className="col-sm-3 col-form-label">Category name</label>
                                                <div className="col-sm-9">
                                                    <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-3 col-form-label">Background Image</label>

                                                <div className="col-sm-9">
                                                    <img className="img-fluid rounded mr-3" width={85} src={imgData} alt="Foodoor" />
                                                    {/* <img src={imgData} /> */}
                                                </div>
                                                <label className="col-sm-3 col-form-label"></label>
                                                <div className="col-sm-3">

                                                    <input type="file" className=" form-control custom-file-input"
                                                        // value={image} 
                                                        onChange={submitHandler}
                                                    />
                                                    <label className="custom-file-label">Change image</label>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-3 col-form-label">Icon</label>

                                                <div className="col-sm-9">
                                                    <img className="img-fluid rounded mr-3" width={85} src={icon} alt="Foodoor" />
                                                </div>
                                                <label className="col-sm-3 col-form-label"></label>
                                                <div className="col-sm-3">

                                                    <input type="file" className=" form-control custom-file-input"
                                                        // value={icon} 
                                                        onChange={submitHandler1}
                                                    />
                                                    <label className="custom-file-label">Change image</label>
                                                </div>
                                            </div>



                                            <div className="form-group row">
                                                <div className="col-sm-10">
                                                    <button type="submit" className="btn btn-primary">Sign in</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                </div>
            </div >
        </div>
    )
}

function EditSection() {
    const headers = "Edit Category of ID"
    return (
        <div>
            <div id="main-wrapper">
                <MainHeader />
                <Header name={headers} />
                <NavBar />
                {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
                <Body />
                <Footer />
            </div>
        </div>
    )
}

export default EditSection
